<template>
    <svg width="0" height="0" class=“hidden”>
        <symbol fill="none" xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' data-tags='attention,exclamation mark' id="attention_bar">
            <path d='M0,256c0,141.368,114.649,256,256.014,256C397.368,512,512,397.368,512,256C512,114.622,397.368,0,256.014,0C114.649,0,0,114.622,0,256z M284.819,427.882c-8.104,7.216-17.75,10.854-28.58,10.854c-10.986,0-20.715-3.611-28.896-10.723c-8.396-7.271-12.674-17.479-12.674-30.312c0-11.284,4.039-20.986,11.952-28.896c7.885-7.917,17.722-11.924,29.111-11.924c11.413,0,21.281,3.979,29.351,11.896c8.104,7.91,12.216,17.64,12.216,28.924C297.299,410.368,293.104,420.5,284.819,427.882z M295.562,168.389l-10.527,105.757c-1.181,15.021-6.903,42.799-6.903,42.799l-43.038,0.264c0,0-8.819-27.694-10.316-43.521l-7.861-102.518c-1.497-23.205-4.812-73.26-4.812-73.26l87.792-0.507C299.896,97.403,296.715,157.16,295.562,168.389z ' transform='translate(0,0) scale(0.03125,0.03125)' fill='#F2BB3A'></path>
        </symbol>
        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" id="icon_arrow_up_black">
            <path d="M6 0L0 6l1.41 1.41L6 2.83l4.59 4.58L12 6 6 0z" fill="#EF0000"></path>
        </symbol>
        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" id="icon_arrow_down_black">
            <path d="M10.59.59L6 5.17 1.41.59 0 2l6 6 6-6L10.59.59z" fill="#BEBEBE"></path>
        </symbol>
        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" id="icon_arrow_down_red">
            <path d="M10.59.59L6 5.17 1.41.59 0 2l6 6 6-6L10.59.59z" fill="#EF0000"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 17" id="icon_check_mark">
            <path d="M8.5 17L0 10.074l3-3.148 5.3 4.198L19.55 0 23 2.728z" fill="#EF0000"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 17" id="icon_check_mark_black">
            <path d="M8.5 17L0 10.074l3-3.148 5.3 4.198L19.55 0 23 2.728z" fill="#1C1C1C1"></path>
        </symbol>
         <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 40" id="icon_arrow_right">
            <path d="M4 0L0 4l16 16L0 36l4 4 20-20z" fill="#FFFFFF" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 40" id="icon_arrow_right_red">
            <path d="M4 0L0 4l16 16L0 36l4 4 20-20z" fill="#EF0000" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 40" id="icon_arrow_right_black">
            <path d="M4 0L0 4l16 16L0 36l4 4 20-20z" fill="#222222" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 40" id="icon_arrow_left">
            <path d="M20 40l4-4L8 20 24 4l-4-4L0 20z" fill="#EF0000" fill-rule="evenodd"></path>
        </symbol>
        <symbol id="horizontal_line_white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <line x1="0" y1="0" x2="300" y2="0" stroke="white" stroke-width="30"/>
        </symbol>
        <symbol id="horizontal_line_red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <line x1="0" y1="0" x2="300" y2="0" stroke="#EF0000" stroke-width="30"/>
        </symbol>
        <symbol version="1.1" id="tick-black-thick" xmlnsSvg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 33.4 29.7">
            <g transform="translate(0,0)">
            <path d="M11,27.7l-9.2-9.9l1.1-1l8,8.6L30.3,1.8l1.2,1L11,27.7z"></path>
            </g>
        </symbol>
        <svg class="icon">
            <use xlink:href="#tick-black-thick"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_up_black"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_down_black"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_down_red"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_check_mark"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_check_mark_black"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_right"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#horizontal_line_white"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#horizontal_line_red"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_right_red"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_right_black"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#icon_arrow_left"></use>
        </svg>
        <svg class="icon">
            <use xlink:href="#attention_bar"></use>
        </svg>
    </svg>
</template>

<script>
export default {
    name: 'SvgSprites'
}
</script>
